<div class="hvb_footer">
  <div class="line">
    <hr>
  </div>
  <div class="footer-logo-container">
    <img class="footer-logo" alt="HVB Footer Logo" src="../../../assets/img/start-page/HVB_Logo.svg">
  </div>
  <div class="footer-text-container">
    <a [routerLink]="Route.IMPRINT" class="footer-text-item imprint-link">
      {{'startPage.footer.imprint'|translate}}
    </a>
    <a [routerLink]="Route.DATAPROTECTION" class="footer-text-item data-protection-link">
      {{'startPage.footer.dataProtection'|translate}}
    </a>
    <a [routerLink]="Route.DOWNLOADS" class="footer-text-item downloads-link">
      {{'startPage.footer.downloads'|translate}}
    </a>
    <a [routerLink]="Route.CONTACT" class="footer-text-item contact-link">
      {{'startPage.footer.contact'|translate}}
    </a>
  </div>
</div>
